export default __webpack_public_path__ + "static/media/FIRE.d292a5c3.png";